import TBCH from "../static/tbch logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function Dashboard() {
  const forward = useNavigate();
  const [logIn, setLogIn] = useState({
    isLoggedIn: false,
    userInfo: {
      name: "",
      id: "",
    },
  });

  const [messages, setMessages] = useState([]);
  const [sidebar, setSidebar] = useState(false);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem("current-user")) {
      forward("/");
    }
  }, [forward]);

  const clearLocalStorage = () => {
    setLogIn({ ...logIn, isLoggedIn: false, userInfo: { name: "", id: "" } });
    return localStorage.removeItem("current-user");
  };

  useEffect(() => {
    document.title = "Dashboard | TBCH";
    axios
      .post(
        "/_tbch-api/verify",
        {},
        {
          headers: {
            "auth-token": localStorage.getItem("current-user") || "",
          },
        }
      )
      .then((d) => {
        d.data
          ? setLogIn({
              ...logIn,
              isLoggedIn: true,
              userInfo: { name: d.data.name, id: d.data._id },
            })
          : clearLocalStorage();
      })
      .catch((e) => {
        alert("Error on server.");
      });
  }, []);

  useEffect(() => {
    if (logIn.userInfo.name.length !== 0) {
      setFetching(true);
      axios
        .post("/_tbch-api/get-messages", { name: logIn.userInfo.name })
        .then((d) => {
          setMessages([]);
          setFetching(false);
          Object.values(d.data.message).map((d) => {
            setMessages((arr) => [...arr, d]);
          });
        })
        .catch((e) => {
          alert("Error on server.");
        });
    }
  }, [logIn]);

  const handleLogout = () => {
    localStorage.clear("current-user");
    return window.location.reload();
  };

  const sideBar = () => {
    if (sidebar) {
      return setSidebar(false);
    } else {
      return setSidebar(true);
    }
  };

  return (
    <div className="main">
      <nav
        className="mobile-nav"
        style={
          sidebar
            ? { transform: "translateX(0%)" }
            : { transform: "translateX(100%)" }
        }
      >
        <div className="close-button-wrap">
          <i class="lni lni-cross-circle" onClick={sideBar}></i>
        </div>
        <div className="choices">
          <span>
            <Link to="/">Home</Link>
          </span>
          <span onClick={handleLogout}>
            <Link to="/">Log Out</Link>
          </span>
        </div>
        <img src={TBCH} alt="" />
        <div className="mark">
          <span>@ctxsoftwaresphilippines</span>
          <span>@charliecatxph</span>
          <span>
            Designed and developed by : Charl Concepcion, CEO of CTX Softwares
            Philippines
          </span>
        </div>
      </nav>
      <section className="dash-page bg-src">
        <div className="darken"></div>
        <nav className="nav-bar">
          <div className="container">
            <div className="logo">
              <img src={TBCH} alt="" />
            </div>
            <div className="navbar-buttons">
              <div className="button">
                <span>
                  <Link to="/">Home</Link>
                </span>
              </div>
              <div className="button">
                <span onClick={handleLogout}>
                  <Link to="/">Log Out</Link>
                </span>
              </div>
            </div>
            <div className="burger-menu-btn" onClick={sideBar}>
              <i class="lni lni-menu"></i>
            </div>
          </div>
        </nav>
        <div className="container">
          <div className="main-dashboard">
            <div className="dash-title">
              <h1>Dashboard</h1>
              <span>Welcome to TBCH, {logIn.userInfo.name}!</span>
            </div>
            <div className="your-sharable-link">
              <h2>Your link:</h2>
              <span>
                {window.location.href.replace(
                  /dashboard.*$/gi,
                  logIn.userInfo.name
                )}
              </span>
            </div>
            <div className="messages">
              <h1>Messages:</h1>
              <div className="messages-main">
                {fetching ? (
                  "Getting messages..."
                ) : messages.length === 0 ? (
                  <span>No messages yet. Go share your link!</span>
                ) : (
                  messages.map((d) => {
                    return (
                      <div className="message">
                        <h1>📧</h1>
                        <span>{d}</span>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
